import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { CreateInnerBoxCodeData, CreatePartDetailData, GetPartBarcodeDetailList, GetPartBarcodeDetailPageList } from '@/api/DeliveryCode';
import { GetDetailList } from '@/api/MaintainDeliveryNote2';
import { mapActions, mapGetters } from 'vuex';
import XEUtils from 'xe-utils';
import util from '@/libs/util';
import changeOrderDialog from './changeOrderDialog';
export default {
  components: {
    changeOrderDialog: changeOrderDialog
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var DELIVERY_QTYValid = function DELIVERY_QTYValid(cellValue) {
      var DELIVERY_QTY = Number(cellValue.DELIVERY_QTY);

      if (DELIVERY_QTY === 0) {
        return new Error('货数量数量不能为0');
      }
    };

    var SPQValid = function SPQValid(cellValue) {
      // console.log('cellValue',cellValue);
      // console.log(cellValue.row.DELIVERY_QTY);
      var SPQ = Number(cellValue.cellValue);
      var QTY = cellValue.row.DELIVERY_QTY; // console.log('SPQ',SPQ);
      // console.log('QTY',QTY);

      if (SPQ === 0) {
        return new Error('内包装数量不能为0');
      } else if (SPQ > QTY) {
        return new Error('内包装数量不能大于送货数量');
      }
    };

    return {
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      editConfig: {
        trigger: null,
        mode: null,
        showStatus: true
      },
      canEdit: false,
      vxeRules: {
        DELIVERY_QTY: [{
          required: true,
          message: '送货数量必须填写'
        }, {
          validator: DELIVERY_QTYValid
        }],
        SPQ: [{
          required: true,
          message: '内箱包装数量必须填写'
        }, {
          validator: SPQValid
        }]
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/DeliveryNote', ['setOrderStatu'])), {}, {
    // 单行打印
    handleRowPrint: function handleRowPrint(row) {
      this.$emit('handleRowPrint', row);
    },
    // 设置数据
    setData: function setData(data) {
      this.tabelData = data;
    },
    vxeFormatDate: function vxeFormatDate(_ref) {
      var cellValue = _ref.cellValue;
      return XEUtils.toDateString(cellValue, 'yyyy-MM-dd');
    }
  }),
  watch: {
    $DeliveryCodeOrderState: {
      handler: function handler(nawValue) {
        if (nawValue === 'listShow') {
          this.tabelData = [];
        }
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DeliveryCodeOrderState', 'userinfo'])),
  beforeDestroy: function beforeDestroy() {
    console.log('销毁');
    this.setOrderStatu('listShow');
  }
};